import { BlockVariant } from "src/types";

import Button from "@/components/editor/primitives/button/button-component";
import { DEFAULT_NAVIGATION_LINKS } from "@/components/editor/shared/navigation";
// import brandMaxiCoverBackgroundImage from "@/components/editor/themes/starter-hub/blocks/covers/brand-maxi-cover/default-background-2.jpg";
import { DEFAULT_ABOUT_DETAILS } from "@/components/editor/themes/starter-hub/blocks/covers/constants";
import StandaloneNavigation from "@/components/editor/themes/starter-hub/blocks/covers/standalone-navigation/standalone-navigation-component";
import Schedules from "@/components/editor/themes/starter-hub/blocks/schedules/default-schedule/default-schedule-component";
import SyncedSchedules from "@/components/editor/themes/starter-hub/blocks/schedules/default-schedule/synced-default-schedule-component";
import AboutDetails from "@/components/editor/themes/starter-hub/blocks/sections/about-details/about-details-component";
import { DEFAULT_SPEAKERS } from "@/components/editor/themes/starter-hub/blocks/speakers/constants";
import Speakers from "@/components/editor/themes/starter-hub/blocks/speakers/speakers-component";
import SyncedSpeakers from "@/components/editor/themes/starter-hub/blocks/speakers/synced-speakers-component";
import { conditionalShowList } from "@/hooks/use-widget-deprecation";
import humanizeDateRange from "@/utils/dates/humanizeDateRange";
import getInitialItemsOrDefault from "@/utils/get-initial-items-or-default";

import {
  DEFAULT_HEADING_TEXT,
  DEFAULT_SCHEDULES,
  DEFAULT_SUBHEADING_TEXT,
} from "../../shared/constants";
import { createThemeTemplateFactory, syncNavigationLinks } from "../utils";
import BrandMaxiCover from "./blocks/covers/brand-maxi-cover/brand-maxi-cover-component";

export default createThemeTemplateFactory(
  (options) =>
    [
      <StandaloneNavigation key="standalone-navigation" showCta isSticky>
        {DEFAULT_NAVIGATION_LINKS.map(({ label, action }) => (
          <Button isLink key={label} text={label} action={action} />
        ))}
      </StandaloneNavigation>,
      <BrandMaxiCover
        key="brand-maxi-cover"
        heading={options.event.name || DEFAULT_HEADING_TEXT}
        subheading={DEFAULT_SUBHEADING_TEXT}
        ctaText={humanizeDateRange(
          options.event.time_start,
          options.event.time_end,
          options.event.standard_timezone
        ).join(" - ")}
        backgroundImage="/canvas/seldon/images/default-background-2.65408416.jpg"
        isLogoShowing
        logoSize={50}
        imageFit="cover"
      />,
      <AboutDetails
        key="about-details"
        defaultDetails={DEFAULT_ABOUT_DETAILS}
      />,
      ...conditionalShowList(BlockVariant.MANUAL, options, [
        <Speakers
          key="speakers"
          speakers={getInitialItemsOrDefault(
            options.speakers,
            8,
            DEFAULT_SPEAKERS
          )}
          layout="large-cards"
        />,
        <Schedules
          key="schedules"
          title="Schedule highlights"
          schedules={
            options.schedules.length > 0 ? options.schedules : DEFAULT_SCHEDULES
          }
        />,
      ]),
      ...conditionalShowList(BlockVariant.SYNCED, options, [
        <SyncedSpeakers key="synced-speakers" layout="large-cards" />,
        <SyncedSchedules key="synced-schedules" title="Schedule highlights" />,
      ]),
    ].filter((e) => Boolean(e)),
  (nodeTrees, query) => syncNavigationLinks(nodeTrees, query)
);
